module.exports = __webpack_public_path__ + "static/media/Fort_Fisher_History_Museum_Kure_Beach_NC_mural_installed_4.8d150797.webp";